<template>
  <v-overlay v-model="showOverlay" class="align-center justify-center">
    <v-progress-circular color="primary" indeterminate size="64">
    </v-progress-circular>
  </v-overlay>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["loadingState"]),
    showOverlay() {
      return this.loadingState;
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
